export const openRulebook = '#open-rulebook'
